import React from 'react'
import { Grid } from '@/components/Grid'
import viewImage from '@/images/view.png'
import { useGlobalStore } from '@/stores/globalStore'
import InfoIcon from '../icons/InfoIcon'
import useResponsive from '@/hooks/useResponsive';
import MobileEmployeeItem from './MobileEmployeeItem';
import { formatPhoneNumber } from '@/utils/helpers/phone.helpers'
import PointIcon from '../icons/PointIcon'
import { useMapStore } from '@/stores/mapStore'


export const EmployeeMobileListItem: React.FC<any> = ({ user }) => {
    const { setEmployee } = useGlobalStore()
    const { id, display, fields } = user

    const openUser = () => setEmployee(id)

    return (
        <MobileEmployeeItem
            name={display}
            fields={fields}
            openUser={openUser}
        />
    )
}

const EmployeeListItem: React.FC<any> = ({ template, columns, item }) => {
    const { setEmployee } = useGlobalStore()
    const { id, data } = item
    console.log('parent_layer_id:', item.parent_layer_id)
    const setSeat = useGlobalStore((state) => state.setSeat)
    const setSeatEmployee = useGlobalStore((state) => state.setSeatEmployee)
    const setActiveLayer = useGlobalStore((state) => state.setActiveLayer)
    const setZoomSeat = useMapStore((state) => state.setZoomSeat)

    const openUser = () => setEmployee(id)

      const handleSeatView = (e) => {
        e.preventDefault()

        setActiveLayer(Number(item.parent_layer_id))
        setSeatEmployee(null)
        setSeat(Number(item.bookable_id))
        setZoomSeat(Number(item.bookable_id))
    }

    return (
        <Grid.Row $cols={template} style={ {paddingLeft: '10px', paddingRight: '15px', alignItems: 'center'} }>
            {data.map(({ label, value, type }, idx) => (
                <Grid.Item key={idx}>
                    {type === 'phone' ? formatPhoneNumber(value) : value}
                </Grid.Item>
            ))}
            {/* <Grid.Item>{item.id}</Grid.Item>
            <Grid.Item>{item.name}</Grid.Item>

            <Grid.Item>{item.department || 'Не указано'}</Grid.Item>
            <Grid.Item>{item.email}</Grid.Item>
            <Grid.Item>{item.phone}</Grid.Item> */}
            <Grid.Item
                style={{
                    display: 'flex',
                    gap: '10px',
                    marginLeft: "-10px"
                }}
            >
                <a href="#" onClick={openUser}>
                   <InfoIcon color="#2C2C2C"  />
                </a>

                <a href="#" onClick={handleSeatView}>
                    <PointIcon color="#2C2C2C" />
                </a>

            </Grid.Item>
        </Grid.Row>
    )
}

export default EmployeeListItem